import {I18n} from '@aws-amplify/core';

import {SimplePageHeader} from '@flexinet/ui-components';

import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions';
import {rbacActions} from '../../../config/rbac/actions';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton';
import {AddRecordButton} from '../buttons/AddRecordButton';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton';

/**
 * The index toolbar (§2).
 *
 * `tools` is an ARRAY of button elements each with a stable key — the toolbar
 * contract — not a hand-built <Group>.
 *
 * Order is [Reload, Filter] then Delete/Add, matching the sibling modules in
 * console-app (`applications`, `accounts`, `organizations`, `users` all build
 * it this way). FNP-918 added the Filter button; the rest is unchanged.
 *
 * Delete and Add are gated on RBAC and HIDDEN, not disabled, when the action is
 * not permitted (§2, §10).
 */
const useTools = (selectedIds: string[], onDeleteComplete?: () => void) => {

    const {allowedActions} = useVerifiedPermissions();

    const tools = [
        <ReloadRecordsButton key='reload'/>,
        <FilterRecordsButton key='filter'/>,
    ];

    if (allowedActions.includes(rbacActions.DeleteSubscription)) {
        tools.push(
            <DeleteRecordButton
                key='delete'
                selectedIds={selectedIds}
                onDeleteComplete={onDeleteComplete}
            />,
        );
    }

    if (allowedActions.includes(rbacActions.CreateSubscription)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

interface IndexPageHeaderProps {
    selectedIds?: string[];
    onDeleteComplete?: () => void;
}

export const IndexPageHeader = ({
                                    selectedIds = [],
                                    onDeleteComplete,
                                }: IndexPageHeaderProps) => (
    <SimplePageHeader
        title={I18n.get('Subscriptions')}
        tools={useTools(selectedIds, onDeleteComplete)}
    />
);
